'use client';
import { Box } from '@mui/material';
import { BodyMedium } from '../../styles';
import { ModalDialog } from '../modal-dialog/ModalDialog';
import React from 'react';

/**
 * Object with user readable title and description used to display inside an ErrorDialog.
 */
export type LocalizedError = {
    title: string;
    description: string;
};

type Props = {
    error: LocalizedError;
    open: boolean;
    onClose: () => void;
};

export const ErrorDialog = ({ error, open, onClose }: Props) => {
    return (
        <ModalDialog
            title={error.title}
            open={open}
            onClose={onClose}
            onSubmit={onClose}
            hideCancel
        >
            <Box py={2} minWidth={'200px'} maxWidth={'350px'}>
                <BodyMedium whiteSpace={'pre-line'}>{error.description}</BodyMedium>
            </Box>
        </ModalDialog>
    );
};
